module.exports = __webpack_public_path__ + "static/media/icon_count_white.8bddf33d.svg";